import { render, staticRenderFns } from "./CMCurssSidebarSelector.vue?vue&type=template&id=515bd590&scoped=true&lang=pug"
import script from "./CMCurssSidebarSelector.vue?vue&type=script&lang=js"
export * from "./CMCurssSidebarSelector.vue?vue&type=script&lang=js"
import style0 from "./CMCurssSidebarSelector.vue?vue&type=style&index=0&id=515bd590&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515bd590",
  null
  
)

export default component.exports